import api from "../config/api";
import handleResponse from "./ResponseHandler";
import pRetry from 'p-retry';

async function addMetadata(
    assetId: string,
    metadataField: string,
    metadataValue: string,
    idToken: string
) {
    return  await pRetry(() => run(assetId,metadataField,metadataValue,idToken), {
        onFailedAttempt: error => {
            console.info(`Attempt ${error.attemptNumber} to set meta data failed. There are ${error.retriesLeft} retries left.`);
        },
        retries: 5})
}

const run = async (
    assetId: string,
    metadataField: string,
    metadataValue: string,
    idToken: string
)=> {
    const options = {
        method: "POST",
        headers: {
            Accept: "application/json, text/plain, */*",
            idtoken: idToken,
            "Content-Type": "application/json"
        }
    };
    const url =
        "/asset/" +
        assetId.toLowerCase() +
        "/metadata?" +
        metadataField +
        "=" +
        metadataValue;

    const response = await fetch(api.base + url, options)

    if (!response.ok) {
        throw new Error(response.statusText);
    }
    const res =  handleResponse(response);
    return res.json().then((data) => {
        return data;
    })

}



export default addMetadata;
